import { environment } from '../../../environments/environment';
import { OpcaoMenuFlutuante } from '../../shared/components/app-layer/header/menu-flutuante/menu-flutuante.types';
import { LABELS_HOME } from './labels-home';

const cards = LABELS_HOME.outrasConsultas.cards;

export const OPCOES_MENU_OUTRAS_CONSULTAS: OpcaoMenuFlutuante[] = [
    {
        nome: cards.mapas.titulo,
        link: '/paineis-analiticos/mapas',
        ilustracao: '/svg/ilustracoes/card-mapas.svg',
        disponivel: environment.featureFlags.enableAnalyticalVisualizations,
    },
    {
        nome: cards.graficos.titulo,
        link: '/paineis-analiticos/dispersao',
        ilustracao: '/svg/ilustracoes/card-graficos.svg',
        disponivel: environment.featureFlags.enableAnalyticalVisualizations,
    },
    {
        nome: cards.basesDados.titulo,
        link: '/bases-de-dados',
        ilustracao: '/svg/ilustracoes/card-base-dados.svg',
        disponivel: true,
    },
];
